import { useSelector, useDispatch  } from "react-redux";
import { Button, Grid,Text} from '@mantine/core';
import intl from "react-intl-universal";


export function UpateMeetingDocs(props:any) {
  const dispatch = useDispatch()  
  const drnId = useSelector((state: any) => state.user.meetinginfo.drnId)
  
  const refreshdocs = () => {
    const refreshdocspayload ={
      drnId: drnId,
  }   
  //handleOpenscreen();
  dispatch({ type: 'SIGNALR_GET_REFRESHDOCS', payload: refreshdocspayload});
  props.handleUpdateDocsclose()
  }

  return (
    <>
    <Text>{intl.get('SETUP_DOCUPDATE_TEXT')} </Text>
    <hr />
   <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green"  onClick={refreshdocs}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" variant="light" onClick={props.handleUpdateDocsclose}>{intl.get('DIALOG_BUTTON_NO_CLOSE')}</Button>
            </Grid.Col>
          </Grid>
    </>
  );
}